export const FETCH_FAQ_LIST_REQUEST = 'faq/FETCH_LIST_REQUEST';
export const FETCH_FAQ_LIST_SUCCESS = 'faq/FETCH_LIST_SUCCESS';
export const FETCH_FAQ_LIST_FAILURE = 'faq/FETCH_LIST_FAILURE';

